export const GET_UPSELL_REQUEST = 'GET_UPSELL_REQUEST';
export const GET_UPSELL_SUCCESS = 'GET_UPSELL_SUCCESS';